import RailsNestedForm from 'stimulus-rails-nested-form'

// Connects to data-controller="nested-form"
export default class extends RailsNestedForm {
}
